import {DAG_ConnectionAttemptSource, type DAG_ConnectionAttempt} from "~/domainModels/dag/dataSourceConnectionAttempt";
import type {QueryClient} from "@tanstack/react-query";
import {redirect} from "@tanstack/react-router";
import {PageType} from "@vesta/vos-types/modules/workspaceLevel/workspaceUiConfigs/domain/WorkspaceConfig";
import {getEnabledWorkspaceUiConfigWithCaching} from "~/utilities/queries";
import {setWorkspaceConfigFromUiConfig} from "~/workspaceConfig/configRuntime";
import {resolveConfigPageIdByType} from "~/workspaceConfig/configPageIds";
import {CONFIG_PAGE_ROUTE_TO} from "~/workspaceConfig/configPageRoutes";

export enum ThirdPartyPlatformIds {
    // ads
    amazon = "457f3f98-a586-4659-8c65-26f76cd74fef",
    // seller, vendor
    amazonMarketplace = "f5c1075b-e5b3-4ce8-9b25-d42fb23659a7",
    facebook = "a547a326-362f-4c39-962c-033274d1180d",
    flipkart = "4928d306-bc11-4c48-8ad4-7b6a32f0e737",
    google = "b9178838-39d1-4986-b3a5-a42d428cecaa",
    linkedIn = "9265d2ea-fa77-4827-9918-f377c01dd17c",
}

export async function getConnectionPageNavigation(args: {
    connectionAttempt: DAG_ConnectionAttempt;
    intellsysBaseUrl: string;
    accessToken: string;
    queryClient: QueryClient;
}) {
    const attempt = args.connectionAttempt;
    const result = await getEnabledWorkspaceUiConfigWithCaching({
        workspaceId: attempt.workspaceId,
        intellsysBaseUrl: args.intellsysBaseUrl,
        accessToken: args.accessToken,
        queryClient: args.queryClient,
    });
    if (result.success !== true) {
        throw result.error;
    }
    if (result.data === null) {
        throw new Error("This workspace does not have an enabled UI configuration.");
    }
    setWorkspaceConfigFromUiConfig(attempt.workspaceId, result.data.configuration);
    const pageType =
        attempt.source === DAG_ConnectionAttemptSource.dataSourcePage
            ? PageType.DataSourceDetail
            : attempt.source === DAG_ConnectionAttemptSource.onboardingPage
              ? PageType.ConnectDataSources
              : undefined;
    if (pageType === undefined) {
        throw new Error("Unsupported connection attempt source.");
    }
    return {
        to: CONFIG_PAGE_ROUTE_TO,
        params: {workspaceId: attempt.workspaceId, pageKey: resolveConfigPageIdByType(attempt.workspaceId, pageType)},
        search:
            attempt.source === DAG_ConnectionAttemptSource.dataSourcePage
                ? {dataSourceId: attempt.dataSourceId, connectionAttemptId: attempt.id}
                : {onboardingJourneyId: attempt.onboardingJourneyId, connectionAttemptId: attempt.id},
        replace: true,
    };
}

export async function redirectToConnectionPage(args: Parameters<typeof getConnectionPageNavigation>[0]): Promise<never> {
    throw redirect(await getConnectionPageNavigation(args));
}
